import { render, staticRenderFns } from "./PLCRequestDropdown.vue?vue&type=template&id=34bbcdc2&scoped=true&"
import script from "./PLCRequestDropdown.vue?vue&type=script&lang=js&"
export * from "./PLCRequestDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PLCRequestDropdown.vue?vue&type=style&index=0&id=34bbcdc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbcdc2",
  null
  
)

export default component.exports